import * as React from "react";
import { Accordion } from "react-bootstrap";
import {
  Icon,
  IconColorStyle,
  IconSize,
  useFlowController,
  useFlowData,
  FlowTypes,
  PopupTip
} from "@adaptis/flow-components";
import { IPetsyExclusionPeriodsProps } from "./PetsyExclusionPeriods.types";
import { tips } from '../PopupTips/tips';
import _ from 'lodash';
import "./PetsyExclusionPeriods.scss";

export default function PetsyExclusionPeriods(props: IPetsyExclusionPeriodsProps) {
  const { getData } = useFlowData();
  let petAgeOnStartDatePolicy = getData("petAgeOnStartDatePolicy");
  let showExtraSummary = petAgeOnStartDatePolicy > 1094 ? false : true;
  const tipName = 'specifiedConditionsTip';
  const tip = _.get(tips, tipName);

  return (
    <div
      data-testid="PetsyExclusionPeriods"
      className={
        "flc_petsy-exclusion-periods " + (props.className ? props.className : "")
      }
    >
      <h2 className="mt-3 mb-3">Exclusion Periods</h2>
      <p className="text-start ">The following Exclusion Periods apply and cover for the associated Condition will only start after the applicable Exclusion Period has elapsed.</p>
      <p className="text-start mb-2">1 day Exclusion Period for Accidental Injury (except Specified Conditions)</p>
      <p className="text-start mb-2">14 day Exclusion Period for Illness (except Specified Conditions)</p>
      {
        showExtraSummary && <>
          <p className="text-start mb-2">14 day Exclusion Period for Dental Illness (for pets under 1 year old)</p>
          <p className="text-start mb-2">6 month Exclusion Period for Dental Illness (for pets 1 year old and over)</p>
          <p className="text-start mb-2">6 month Exclusion Period for Behavioural Conditions</p>
        </>
      }
      <div className="div-as-p text-start mb-2">
        6 month Exclusion Period Specified  
        <span className="conditions-wrap">
          Conditions 
          <PopupTip className="ms-1" tip={tip}></PopupTip>
        </span>
      </div>
      <p className="text-start mb-2"></p>
      <p className="text-start ">Any Injury, Illness, or Specified Condition that occurs during the applicable Exclusion Period will also be deemed to be a Pre-existing Condition</p>
    </div>
  );
}
